/* Kala Futurism — Alive layer: concierge pill + mobile hero metrics tickers. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function injectConciergePill() {
    if (document.querySelector('.kf-concierge-pill')) return;
    var path = window.location.pathname || '';
    if (/\/cart|\/checkout|\/account|\/admin/.test(path)) return;
    if (/\/pages\/concierge/.test(path)) return;
    var a = document.createElement('a');
    a.className = 'kf-concierge-pill';
    a.href = '/pages/concierge';
    a.setAttribute('aria-label', 'Find your library — personalized recommendation');
    a.innerHTML = '<span class="kf-concierge-pill__heart" aria-hidden="true"></span><span>Find your library</span><span class="kf-concierge-pill__arrow" aria-hidden="true">→</span>';
    document.body.appendChild(a);
    setTimeout(function () { a.classList.add('is-in'); }, 1600);
  }

  function injectHeroMetaMetrics() {
    var meta = document.querySelector('.kf-hero .kf-hero__meta');
    if (!meta) return;
    if (document.querySelector('.kf-hero .kf-hero__meta-metrics')) return;
    var wrap = document.createElement('div');
    wrap.className = 'kf-hero__meta-metrics';
    wrap.setAttribute('data-fx', 'fade');
    wrap.innerHTML =
      '<div class="kf-hero__meta-metric"><span class="kf-hero__meta-metric__value"><span class="kf-ticker" data-value="52">0</span></span><span class="kf-hero__meta-metric__label">Weekly units</span></div>' +
      '<div class="kf-hero__meta-metric"><span class="kf-hero__meta-metric__value"><span class="kf-ticker" data-value="240">0</span></span><span class="kf-hero__meta-metric__label">Pages</span></div>' +
      '<div class="kf-hero__meta-metric"><span class="kf-hero__meta-metric__value"><span class="kf-ticker" data-value="12">0</span></span><span class="kf-hero__meta-metric__label">Domains</span></div>' +
      '<div class="kf-hero__meta-metric"><span class="kf-hero__meta-metric__value">0–5</span><span class="kf-hero__meta-metric__label">Years</span></div>';
    meta.parentNode.insertBefore(wrap, meta.nextSibling);
    setTimeout(function () {
      var tickers = wrap.querySelectorAll('.kf-ticker');
      tickers.forEach(function (t) {
        var target = parseFloat(t.getAttribute('data-value')) || 0;
        var duration = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          t.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step); else t.textContent = target;
        }
        requestAnimationFrame(step);
      });
    }, 900);
  }

  ready(function () { injectConciergePill(); injectHeroMetaMetrics(); });
})();
